/**
 * Vitasonar Quiz Funnel — State Machine & Scoring Engine
 * Supports multiple quizzes via data attributes on #quizFunnel
 */
(function () {
  'use strict';

  // Only run on the quiz page
  if (!document.getElementById('quizFunnel')) return;

  // --- DOM Refs ---
  var funnel = document.getElementById('quizFunnel');
  var progressBar = document.getElementById('qfProgressBar');

  // --- Read Config from data attributes (fallback to Quiz 01 defaults) ---
  var config = {
    totalSteps: parseInt(funnel.getAttribute('data-total-steps') || '17', 10),
    totalQuestions: parseInt(funnel.getAttribute('data-total-questions') || '8', 10),
    quizName: funnel.getAttribute('data-quiz-name') || 'Menopauze Support Plan',
    klaviyoList: funnel.getAttribute('data-klaviyo-list') || 'Up4uqY',
    propertyPrefix: funnel.getAttribute('data-property-prefix') || 'Quiz - Menopauze',
    profileNames: JSON.parse(funnel.getAttribute('data-profiles') || '{"A":"Slaapverstoorder","B":"Emotionele Achtbaan","C":"Gewicht + Energie","D":"Alles Tegelijk"}'),
    scoreNames: JSON.parse(funnel.getAttribute('data-score-names') || '{"sleep":"Sleep","emotion":"Emotion","weight":"Weight Energy","total":"Total"}'),
    profileLogic: funnel.getAttribute('data-profile-logic') || 'quiz01'
  };

  // Dynamically load CSS — URL is injected at build time by upload script
  var QF_CSS_URL = '';
  if (QF_CSS_URL && QF_CSS_URL.indexOf('%%') === -1) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = QF_CSS_URL;
    document.head.appendChild(link);
  }

  // --- State ---
  var state = {
    currentStep: 0,
    totalSteps: config.totalSteps,
    totalQuestions: config.totalQuestions,
    answers: {},
    // Unprefixed profile properties (e.g. global `age` for cross-quiz segmentation)
    globalProperties: {},
    scores: (function() {
      var s = {};
      var keys = Object.keys(config.scoreNames);
      for (var i = 0; i < keys.length; i++) s[keys[i]] = 0;
      return s;
    })(),
    profile: null,
    email: null
  };

  // --- Step Navigation ---

  function showStep(index) {
    var steps = funnel.querySelectorAll('.qf-step');
    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.remove('qf-step--active');
    }
    var target = funnel.querySelector('[data-step="' + index + '"]');
    if (target) {
      target.classList.add('qf-step--active');
      // Force re-trigger animation
      target.style.animation = 'none';
      target.offsetHeight; // reflow
      target.style.animation = '';
    }
    state.currentStep = index;
    updateProgress();
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Auto-run analyzing animation
    if (target && target.getAttribute('data-type') === 'analyzing') {
      runAnalyzing();
    }
  }

  function updateProgress() {
    // Optional logical progress: a step may carry data-progress (its logical
    // position) and the funnel data-progress-total. Used by branching quizzes
    // where the raw DOM step index does not reflect real progress.
    // Falls back to the original formula when the attributes are absent —
    // existing (linear) quizzes are unaffected.
    var pct;
    var active = funnel.querySelector('[data-step="' + state.currentStep + '"]');
    var pIdx = active && active.getAttribute('data-progress');
    var pTotal = funnel.getAttribute('data-progress-total');
    if (pIdx && pTotal) {
      pct = (parseInt(pIdx, 10) / (parseInt(pTotal, 10) - 1)) * 100;
    } else {
      pct = (state.currentStep / (state.totalSteps - 1)) * 100;
    }
    progressBar.style.width = pct + '%';
  }

  // --- Public: Next / Back / GoTo ---

  // quizNext honors an optional data-goto on the current step (for converging
  // branches). Absent on all linear quizzes → unchanged behavior.
  window.quizNext = function () {
    var cur = funnel.querySelector('[data-step="' + state.currentStep + '"]');
    var goto = cur && cur.getAttribute('data-goto');
    if (goto) { showStep(parseInt(goto, 10)); } else { showStep(state.currentStep + 1); }
  };

  // quizBack honors an optional data-back on the current step (so a branched
  // screen returns to its router instead of a sibling branch). Absent on all
  // linear quizzes → unchanged behavior.
  window.quizBack = function () {
    var cur = funnel.querySelector('[data-step="' + state.currentStep + '"]');
    var back = cur && cur.getAttribute('data-back');
    if (back) { showStep(parseInt(back, 10)); return; }
    if (state.currentStep > 0) {
      showStep(state.currentStep - 1);
    }
  };

  // Jump directly to a step index (used by branching quizzes).
  window.quizGoTo = function (index) {
    showStep(parseInt(index, 10));
  };

  // Slider capture — stores the value on change; the step's button advances.
  window.qfSlider = function (input) {
    var step = input.closest('.qf-step');
    var qid = step.getAttribute('data-id');
    if (qid) state.answers[qid] = input.value;
    var gp = step.getAttribute('data-global-property');
    if (gp) state.globalProperties[gp] = input.value;
    var out = step.querySelector('[data-slider-output]');
    if (out) out.textContent = input.value;
  };

  // --- Single Select ---

  window.selectSingle = function (el) {
    var step = el.closest('.qf-step');
    var questionId = step.getAttribute('data-id');

    // Visual feedback
    var options = step.querySelectorAll('.qf-option');
    for (var i = 0; i < options.length; i++) {
      options[i].classList.remove('qf-option--selected');
    }
    el.classList.add('qf-option--selected');

    // Store answer
    var value = el.getAttribute('data-value');
    state.answers[questionId] = value;

    // Support global (unprefixed) Klaviyo profile properties — e.g. shared `age` across quizzes
    var globalProp = el.getAttribute('data-global-property') || step.getAttribute('data-global-property');
    if (globalProp) {
      state.globalProperties[globalProp] = value;
    }

    // Apply scores from data attributes
    applyScores(el);

    // Auto-advance after brief delay — honor optional data-goto branching
    // (on the option, else the step). Absent on linear quizzes → +1 as before.
    var goto = el.getAttribute('data-goto') || step.getAttribute('data-goto');
    setTimeout(function () {
      if (goto) { showStep(parseInt(goto, 10)); } else { showStep(state.currentStep + 1); }
    }, 300);
  };

  // --- Multi Select ---

  window.toggleMulti = function (el) {
    el.classList.toggle('qf-option--selected');
    updateMultiButton(el.closest('.qf-step'));
  };

  function updateMultiButton(step) {
    var selected = step.querySelectorAll('.qf-option--selected');
    var btn = step.querySelector('.qf-btn');
    if (btn) {
      btn.disabled = selected.length === 0;
    }
  }

  window.submitMulti = function () {
    var step = funnel.querySelector('[data-step="' + state.currentStep + '"]');
    var questionId = step.getAttribute('data-id');
    var selected = step.querySelectorAll('.qf-option--selected');
    var values = [];

    for (var i = 0; i < selected.length; i++) {
      values.push(selected[i].getAttribute('data-value'));
      applyScores(selected[i]);
    }

    state.answers[questionId] = values;
    // Honor optional data-goto on the step (converging branches). Absent on
    // linear quizzes → +1 as before.
    var goto = step.getAttribute('data-goto');
    if (goto) { showStep(parseInt(goto, 10)); } else { showStep(state.currentStep + 1); }
  };

  // --- Score Application ---

  function applyScores(el) {
    var keys = Object.keys(config.scoreNames);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var val = parseInt(el.getAttribute('data-score-' + key) || '0', 10);
      if (val) state.scores[key] = (state.scores[key] || 0) + val;
    }
  }

  // --- Profile Determination ---

  function determineProfile() {
    var s = state.scores;

    // Quiz 01 legacy logic (backward compatible)
    if (config.profileLogic === 'quiz01') {
      var maxSpecific = Math.max(s.sleep || 0, s.emotion || 0, s.weight || 0);
      if ((s.total || 0) >= maxSpecific && (s.total || 0) >= 5) return 'D';
      if ((s.sleep || 0) === maxSpecific && (s.sleep || 0) >= 4) return 'A';
      if ((s.emotion || 0) === maxSpecific && (s.emotion || 0) >= 4) return 'B';
      if ((s.weight || 0) === maxSpecific && (s.weight || 0) >= 4) return 'C';
      return 'D';
    }

    // Generic: highest score category maps to corresponding profile
    var keys = Object.keys(config.scoreNames);
    var profiles = Object.keys(config.profileNames);
    var maxScore = 0;
    var maxKey = keys[0];
    for (var i = 0; i < keys.length; i++) {
      if ((s[keys[i]] || 0) > maxScore) {
        maxScore = s[keys[i]] || 0;
        maxKey = keys[i];
      }
    }
    var keyIndex = keys.indexOf(maxKey);
    if (maxScore >= 3 && keyIndex < profiles.length) {
      return profiles[keyIndex];
    }
    return profiles[profiles.length - 1];
  }

  // --- Email Capture ---

  window.submitEmail = function (e) {
    e.preventDefault();
    var input = document.getElementById('qfEmailInput');
    var email = input.value.trim();
    if (email && email.indexOf('@') > 0) {
      state.email = email;
    }
    // Optional name fields (Klaviyo-native). Absent on quizzes that don't
    // collect names → ignored.
    var fn = document.getElementById('qfFirstName');
    var ln = document.getElementById('qfLastName');
    if (fn && fn.value.trim()) state.firstName = fn.value.trim();
    if (ln && ln.value.trim()) state.lastName = ln.value.trim();
    showStep(state.currentStep + 1);
    return false;
  };

  // --- Analyzing Animation ---

  function runAnalyzing() {
    var bar = document.getElementById('qfAnalyzingBar');
    var steps = funnel.querySelectorAll('[data-analyze-step]');
    var delays = [0, 1000, 2200, 3200];
    var barWidths = [25, 50, 75, 100];

    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.remove('qf-analyzing__step--done');
    }
    bar.style.width = '0%';

    for (var j = 0; j < steps.length; j++) {
      (function (index) {
        setTimeout(function () {
          steps[index].classList.add('qf-analyzing__step--done');
          bar.style.width = barWidths[index] + '%';
        }, delays[index]);
      })(j);
    }

    // After animation, determine profile and show result
    setTimeout(function () {
      state.profile = determineProfile();
      sendToKlaviyo();
      showResult(state.profile);
      showStep(state.currentStep + 1);
    }, 4200);
  }

  // --- Klaviyo Integration ---

  var KLAVIYO_PUBLIC_KEY = 'W6UwJC';

  function sendToKlaviyo() {
    if (!state.email) return;

    var prefix = config.propertyPrefix;
    var pNames = config.profileNames;
    var sNames = config.scoreNames;

    var properties = {};
    properties[prefix + ' - Profile'] = state.profile;
    properties[prefix + ' - Profile Name'] = pNames[state.profile] || 'Onbekend';
    var scoreKeys = Object.keys(sNames);
    for (var i = 0; i < scoreKeys.length; i++) {
      var k = scoreKeys[i];
      properties[prefix + ' - ' + sNames[k] + ' Score'] = state.scores[k] || 0;
    }

    // Merge global (unprefixed) properties — e.g. `age` for cross-quiz segmentation
    var globalKeys = Object.keys(state.globalProperties);
    for (var g = 0; g < globalKeys.length; g++) {
      properties[globalKeys[g]] = state.globalProperties[globalKeys[g]];
    }

    var profileData = {
      email: state.email,
      properties: properties
    };
    if (state.firstName) profileData.first_name = state.firstName;
    if (state.lastName) profileData.last_name = state.lastName;

    // 1. Identify profile + subscribe to list
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Quiz: ' + config.quizName,
              profile: {
                data: {
                  type: 'profile',
                  attributes: profileData
                }
              }
            },
            relationships: {
              list: {
                data: { type: 'list', id: config.klaviyoList }
              }
            }
          }
        })
      });
    } catch (e) { /* fail silently */ }

    // 2. Track quiz completion event
    var eventProps = {
      quiz_name: config.quizName,
      profile: state.profile,
      profile_name: pNames[state.profile] || 'Onbekend',
      answers: state.answers
    };
    for (var j = 0; j < scoreKeys.length; j++) {
      var ek = scoreKeys[j];
      eventProps[sNames[ek].toLowerCase() + '_score'] = state.scores[ek] || 0;
    }

    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_PUBLIC_KEY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              metric: { data: { type: 'metric', attributes: { name: 'Quiz Completed' } } },
              profile: { data: { type: 'profile', attributes: { email: state.email } } },
              properties: eventProps
            }
          }
        })
      });
    } catch (e) { /* fail silently */ }
  }

  // --- Show Result ---

  function showResult(profile) {
    var profiles = funnel.querySelectorAll('.qf-result-profile');
    for (var i = 0; i < profiles.length; i++) {
      profiles[i].classList.remove('qf-result-profile--active');
    }
    var target = funnel.querySelector('[data-profile="' + profile + '"]');
    if (target) {
      target.classList.add('qf-result-profile--active');
    }
  }

  // --- Init ---
  showStep(0);

  // --- Defensive: lock our window handlers so a legacy quiz-funnel.js loaded
  // via CDN ScriptTag cache can't overwrite them after we install ours.
  // (Branching/slider/back live in this engine version only — losing them
  // would silently break new quizzes.)
  var locked = ['quizNext', 'quizBack', 'quizGoTo', 'qfSlider', 'selectSingle',
                'toggleMulti', 'submitMulti', 'submitEmail'];
  for (var li = 0; li < locked.length; li++) {
    var name = locked[li];
    var fn = window[name];
    if (typeof fn !== 'function') continue;
    try {
      Object.defineProperty(window, name, {
        value: fn, writable: false, configurable: false
      });
    } catch (e) { /* fail silently — non-modern env */ }
  }

})();

/* build:1779371054 */
